import React from 'react';
import OeTip from './OeTip';

/**
 * Schwebende Speicherleiste unten links (Original `.savebar` HTML 741–744 und
 * `updateSum` 5351).
 *
 * Sie erscheint nur, wenn es etwas zu speichern gibt oder eine Statusmeldung
 * steht — auf einem unveränderten Beleg soll nichts im Weg liegen. Der Knopf
 * nennt die Zahl der Änderungen, damit vor dem Klick klar ist, wie viel
 * hinausgeht.
 *
 * @param {number} count - Zahl der offenen Änderungen.
 * @param {{running: boolean, phase: string, pct: number, restSec: ?number, status: ?object}} save
 * @param {boolean} locked - gesperrter Beleg: kein Speichern anbieten.
 * @param {() => void} onSave
 */
export default function SaveBar({count, save, locked, onSave}) {
    const zeigeKnopf = !locked && count > 0;
    const status = save.running
        ? {tone: 'work', text: save.phase || 'Speichern gestartet…'}
        : save.status;

    if (!zeigeKnopf && !status) {
        return null;
    }

    return (
        <div className="savebar show">
            {status ? (
                <span className={`status ${status.tone}`} role="status">
                    {status.text}
                    {status.weclappUrl ? (
                        <>
                            {'  ·  '}
                            <a className="wl" href={status.weclappUrl} target="_blank" rel="noopener noreferrer">
                                zurück zu weclapp ↗
                            </a>
                        </>
                    ) : null}
                    {save.running ? (
                        <>
                            <div className="pbar">
                                <div className="pfill" style={{width: `${save.pct || 0}%`}}/>
                            </div>
                            <div className="ptext">
                                {save.phase}
                                {save.restSec != null ? ` · ${save.pct} % · noch ~${save.restSec} s` : ''}
                            </div>
                        </>
                    ) : null}
                </span>
            ) : null}

            {zeigeKnopf ? (
                <OeTip
                    placement="top"
                    tip={'Zeigt zuerst alle Änderungen zum Prüfen. Erst danach geht das Speichern nach weclapp — '
                        + 'bei festgeschriebenen Aufträgen dauert das ein bis zwei Minuten, weil der Beleg neu erzeugt wird.'}
                >
                    <button
                        type="button"
                        id="oe-saveBtn"
                        disabled={save.running}
                        onClick={onSave}
                    >
                        {count} Änderung{count > 1 ? 'en' : ''} speichern
                    </button>
                </OeTip>
            ) : null}
        </div>
    );
}
